module.exports = __webpack_public_path__ + "static/media/Abendum-logo.b3c88601.png";